import mixpanel from 'mixpanel-browser'

const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN

export const events = {
  returnCompleted: 'Return completed',
}

export const initMixpanel = () => {
  if (mixpanelToken) {
    mixpanel.init(mixpanelToken, {
      api_host: 'https://api-eu.mixpanel.com',
      persistence: 'localStorage',
    })
    mixpanel.reset()
  }
}

export const identify = userId => {
  if (mixpanelToken && userId) mixpanel.identify(userId)
}

export const registerExperiment = (experiment, value, payload) => {
  if (mixpanelToken) {
    const data = { experiment, variant: value }
    if (payload) data.experiment_payload = payload
    mixpanel.register(data)
  }
}

export const sendEvent = (eventName, properties = null) => {
  if (mixpanelToken) {
    mixpanel.track(eventName, properties)
  }
}
